import { connect } from "react-redux";
import { Link } from "react-router-dom";
import React, { Component } from "react";

import { admin_cse, adminRoute } from "@/config/roles";
import { adminRequests } from "@/api/(requests)/admin";
import { getAutomationDataAttr } from "@/utils/automationUtils";
import { getQueryParams } from "@/utils/filters";
import { isAuthorized } from "@/utils/authToken";
import PatientsList from "@/portals/(shared)/(patient-list)/PatientsList";
import { ProviderPracticeDetails } from "@/components/Admin/Provider/ProviderPracticeDetails";
import { ProviderStatusDetails } from "@/components/Admin/Provider/ProviderStatusDetails";
import { sharedRequests } from "@/api/(requests)/shared";
import { ViewContent2 } from "@/components/layout/ViewContent";

import { ProviderDetailsForm } from "./components/ProviderDetailsForm";

class Provider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hideBreadCrumb: getQueryParams("hideBreadCrumb", this.props.location.search),
      practiceId: this.props.match.params.practiceId,
      providerDetails: null,
      providerId: this.props.match.params.providerId,
      status: null,
    };
  }

  async componentDidMount() {
    await this.getProvider();
    this.getPatientList();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.providerId !== this.props.match.params.providerId) {
      this.setState(
        {
          practiceId: this.props.match.params.practiceId,
          providerId: this.props.match.params.providerId,
        },
        () => this.componentDidMount(),
      );
    }
  }

  async getProvider({ context } = {}) {
    let searchParams = { practiceId: this.state.practiceId, providerId: this.state.providerId };
    let cleanResponse = await sharedRequests.fetch_practice_provider({ context, searchParams });

    this.setState({
      providerDetails: cleanResponse,
    });
  }

  getPatientList() {
    (async () => {
      let searchParams = { providerId: this.state.providerId };
      let cleanResponse = await adminRequests.fetch_patient_list({ searchParams });

      this.setState({
        patientList: cleanResponse.user,
      });
    })();
  }

  render() {
    if (!this.state.providerDetails || !this.state.patientList) {
      return <div />;
    }

    return (
      <ViewContent2>
        <header {...getAutomationDataAttr("ProviderPage")}>
          {!this.state.hideBreadCrumb && (
            <div className="mx-auto fs-14 my-3 py-2">
              <Link to={adminRoute + "/practice"}>
                <p className="d-inline ml-0">Practices</p>
              </Link>

              <Link to={adminRoute + "/practice/" + this.state.practiceId}>
                <p className="d-inline ml-0"> {">"} Practice Details</p>
              </Link>

              <span className="fs-14"> {">"} Provider Details</span>
            </div>
          )}

          <h3 className="fs-25 tw:font-bold">{this.state.providerDetails.name}</h3>
        </header>

        <ProviderDetailsForm providerId={this.state.providerId} />

        {isAuthorized(admin_cse) && (
          <ProviderPracticeDetails providerDetails={this.state.providerDetails} />
        )}

        <ProviderStatusDetails
          providerDetails={this.state.providerDetails}
          // NOTE: this needs to be a new function here so that we have access
          // to the "this" keyword within getProvider
          refetchProvider={(args) => this.getProvider(args)}
        />

        <PatientsList
          {...this.props}
          patientList={this.state.patientList}
          practiceId={this.props.match.params.practiceId}
        />
      </ViewContent2>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    flags: state?.flags || {},
  };
};

export default connect(mapStateToProps, {})(Provider);
